import Link from "next/link";

type RecaptchaNoticeProps = {
  className?: string;
  linkClassName?: string;
};

export function RecaptchaNotice({ className = "", linkClassName = "underline underline-offset-2" }: RecaptchaNoticeProps) {
  return (
    <p className={className}>
      This site is protected by reCAPTCHA and the Google{" "}
      <Link href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className={linkClassName}>
        Privacy Policy
      </Link>{" "}
      and{" "}
      <Link href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className={linkClassName}>
        Terms of Service
      </Link>{" "}
      apply.
    </p>
  );
}
